var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.625,
    height: 14.625,
    viewBox: "0 0 14.625 14.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-close-circle",
    "data-name": "Icon ionic-md-close-circle",
    d: "M10.688,3.375A7.313,7.313,0,1,0,18,10.688,7.287,7.287,0,0,0,10.688,3.375Zm3.656,9.945L13.32,14.344l-2.633-2.633L8.055,14.344,7.031,13.32l2.633-2.633L7.031,8.055,8.055,7.031l2.633,2.632L13.32,7.031l1.024,1.024-2.633,2.633Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#3a404e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCircleIcon);
export default __webpack_public_path__ + "static/media/remove-circle-icon.b87f70fa17656a44ef700d6b019f4e9f.svg";
export { ForwardRef as ReactComponent };